export default __webpack_public_path__ + "device_spotlight_cam_solar.f940e126.png";